import { Paper, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import HomeIcon from '@mui/icons-material/Home';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import BarChartIcon from '@mui/icons-material/BarChart';
import HelpIcon from '@mui/icons-material/Help';

const Navbar = () => {
  return (
    <Paper
      elevation={6}
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        px: { xs: 1, sm: 3 },
        py: { xs: 1, sm: 1.5 },
        borderRadius: '32px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
        position: 'relative',
        width: { xs: '100%', sm: 'auto' },
        maxWidth: { xs: '100%', sm: 900 },
        mx: 'auto',
        mt: { xs: 2, sm: 0 },
        mb: 3,
        background: 'rgba(255,255,255,0.95)',
      }}
    >
      <Button
        color="primary"
        component={RouterLink}
        to="/"
        sx={{
          fontSize: { xs: '1.3rem', sm: '1.1rem' },
          fontWeight: 700,
          textTransform: 'none',
          pl: 0,
          mb: { xs: 1, sm: 0 },
          justifyContent: { xs: 'center', sm: 'flex-start' },
          width: { xs: '100%', sm: 'auto' },
          minWidth: { sm: 'auto' },
          '&:hover': { bgcolor: 'transparent' },
        }}
        disableRipple
      >
        Cloud Image Investigator
      </Button>
      <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', sm: 'auto' } }}>
        <Button
          color="primary"
          component={RouterLink}
          to="/"
          startIcon={<HomeIcon />}
          sx={{ borderRadius: '20px', px: 2, width: { xs: '100%', sm: 'auto' } }}
        >
          Home
        </Button>
        <Button
          color="primary"
          component={RouterLink}
          to="/search"
          startIcon={<SearchIcon />}
          sx={{ borderRadius: '20px', px: 2, width: { xs: '100%', sm: 'auto' } }}
        >
          Search
        </Button>
        <Button
          color="primary"
          component={RouterLink}
          to="/accounts"
          startIcon={<AccountTreeIcon />}
          sx={{ borderRadius: '20px', px: 2, width: { xs: '100%', sm: 'auto' } }}
        >
          Accounts
        </Button>
        <Button
          color="primary"
          component={RouterLink}
          to="/daily-stats"
          startIcon={<BarChartIcon />}
          sx={{ borderRadius: '20px', px: 2, width: { xs: '100%', sm: 'auto' } }}
        >
          Daily Stats
        </Button>
        <Button
          color="primary"
          component={RouterLink}
          to="/faq"
          startIcon={<HelpIcon />}
          sx={{ borderRadius: '20px', px: 2, width: { xs: '100%', sm: 'auto' } }}
        >
          FAQ
        </Button>
      </Box>
    </Paper>
  );
};

export default Navbar; 